import { ReactNode } from 'react';

export interface StatItem {
  value: ReactNode;
  label: ReactNode;
  hint?: ReactNode;
}

interface StatsBarProps {
  items: StatItem[];
  className?: string;
}

export default function StatsBar({ items, className = '' }: StatsBarProps) {
  return (
    <div className={`rounded-2xl border border-border bg-card/40 backdrop-blur ${className}`}>
      <div className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-border">
        {items.map((item, idx) => (
          <div key={idx} className="px-6 py-6 text-center">
            <div className="text-2xl md:text-3xl font-bold tracking-tight text-foreground">
              {item.value}
            </div>
            <div className="mt-1 text-xs md:text-sm text-muted-foreground uppercase tracking-wide">
              {item.label}
            </div>
            {item.hint && (
              <div className="mt-1 text-[11px] text-muted-foreground/70">{item.hint}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
